import UGC from "@/components/UGC.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import { builderCta } from "@/helpers/builder-init/index";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();

export const ugcInit = {
    component: UGC,
    name: "UGC",
    inputs: [
        {
            name: "heading",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string"
                },
                {
                    name: "color",
                    type: "string",
                    enum: colors,
                    showIf: hasValue("text")
                }
            ]
        },
        {
            name: "description",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "richText"
                },
                {
                    name: "color",
                    type: "string",
                    enum: colors,
                    showIf: hasRichText("text")
                }
            ]
        },
        {
            name: "cta",
            type: "object",
            defaultValue: { type: "button", style: "primary" },
            subFields: [...builderCta.subFields]
        },
        {
            name: "image_content",
            helperText: "Min. 4 images",
            type: "list",
            onChange: (options) => {
                if (options.get("image_content").length < 4) {
                    options.set("image_content", [
                        ...options.get("image_content"),
                        options.get("image_content").at(-1)
                    ]);
                    alert("Minimum of 4 images for this component.");
                }
            },
            defaultValue: [
                { media: "" },
                { media: "" },
                { media: "" },
                { media: "" }
            ],
            required: true,
            subFields: [
                {
                    name: "image",
                    type: "file",
                    helperText: "Allowed file types - .jpeg, .png, .svg",
                    allowedFileTypes: ["jpeg", "png", "svg"],
                    required: true
                },
                {
                    name: "alt_text",
                    type: "string",
                    showIf: hasValue("image"),
                    required: true
                },
                {
                    name: "aria_label",
                    type: "string",
                    showIf: hasValue("image"),
                    required: true
                }
            ]
        }
    ]
};
